import { CertificationClaimType } from '@/models/CertificationClaimType'
import CachedResourceStore from '@/store/modules/CachedResourceStore'

export default new CachedResourceStore<CertificationClaimType>(CertificationClaimType, {
	namespaced: true
})
